import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface RightProps {
  children: ReactNode;
  hidden?: boolean;
}

export const Right = ({ children, hidden = false }: RightProps) => {
  if (hidden) {
    return null;
  }

  return (
    <aside
      aria-label={t("right_sidebar")}
      className={anchorClassNames("sidebar sidebar--right")}
      data-testid="sidebar-right"
    >
      <div
        className={anchorClassNames("sidebar__content")}
        data-draggable="false"
      >
        {children}
      </div>
    </aside>
  );
};
